import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const ActionButtonsSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
    </Box>
  );
};

export default ActionButtonsSkeleton;
